
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { AdUnit } from "./components/ads/AdUnit";
import { BackgroundGrid } from "./components/BackgroundGrid";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import Index from "./pages/Index";
import Results from "./pages/Results";
import History from "./pages/History";
import UnitHistory from "./pages/UnitHistory";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Resources from "./pages/Resources";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import FAQs from "./pages/FAQs";

const queryClient = new QueryClient();

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta property="og:site_name" content="UnitCodex" />
        <meta name="application-name" content="UnitCodex" />
        <meta name="apple-mobile-web-app-title" content="UnitCodex" />
      </Helmet>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <div className="flex flex-col min-h-screen relative">
          <ScrollToTop />
          <BackgroundGrid />
          <Navigation />
          <div className="container mx-auto px-4 mt-8">
            <AdUnit 
              adSlot="3043090605"
              className="min-h-[90px] w-full bg-gray-100/50 rounded-lg mb-8"
              adFormat="horizontal"
              desktopOnly
            />
          </div>
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/results" element={<Results />} />
              <Route path="/history" element={<History />} />
              <Route path="/history/:unit" element={<UnitHistory />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/faqs" element={<FAQs />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/about" element={<About />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <div className="container mx-auto px-4 mb-4">
            <AdUnit 
              adSlot="3043090605"
              className="min-h-[90px] w-full bg-gray-100/50 rounded-lg mt-8"
              adFormat="horizontal"
              mobileOnly
            />
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
